import axios from 'axios'
import { envConfig, LOGIN_BOOTSTRAP_TOKEN } from './config'
import { readSession } from './session'

export async function remoteRequest(method, endpoint, options = {}) {
  const config = envConfig()
  const session = readSession()
  const headers = {
    Accept: 'application/json, text/plain, */*',
    'x-api-key': config.apiKey,
    ...(options.headers || {}),
  }

  if (options.bootstrap) headers.token = LOGIN_BOOTSTRAP_TOKEN
  if (options.sabreToken) headers.token = session.sabreToken
  if (options.token) headers.token = options.token
  if (options.jwt !== false && session.jwt) headers.Authorization = session.jwt

  const response = await axios.request({
    baseURL: config.baseURL,
    url: endpoint,
    method,
    params: options.query,
    data: options.body,
    headers,
    timeout: options.timeout || 25000,
  })
  return response.data
}
